import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { format, isSameMonth } from 'date-fns';
import { es } from 'date-fns/locale';
import { Meeting } from '../../../shared/types';

interface CalendarHeaderProps {
  currentDate: Date;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  view: 'month' | 'week' | 'day';
  onViewChange: (view: 'month' | 'week' | 'day') => void;
  meetings: Meeting[];
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentDate,
  onPrevMonth,
  onNextMonth,
  meetings,
}) => {
  const { t } = useTranslation();
  const currentMonthMeetings = meetings.filter(meeting => {
    const meetingDate = new Date(meeting.fields['Fecha Reunión']);
    return isSameMonth(meetingDate, currentDate);
  });

  return (
    <header className="bg-white border-b border-gray-200 py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2.5">
            <h1 className="text-2xl font-semibold text-gray-900">
              {t('calendar.title')}
            </h1>
            <button
              onClick={onPrevMonth}
              className="p-1.5 hover:bg-gray-100"
            >
              <ChevronLeft className="w-5 h-5 text-gray-600" />
            </button>
            <span className="text-lg font-medium text-gray-900">
              {format(currentDate, 'MMMM yyyy', { locale: es })}
            </span>
            <button
              onClick={onNextMonth}
              className="p-1.5 hover:bg-gray-100"
            >
              <ChevronRight className="w-5 h-5 text-gray-600" />
            </button>
            
            <span className="text-gray-500">{currentMonthMeetings.length}</span>
          </div>
        </div>
      </div>
    </header>
  );
};